import { render, staticRenderFns } from "./GraphDetail42.vue?vue&type=template&id=536db134&scoped=true"
import script from "./GraphDetail42.vue?vue&type=script&lang=js"
export * from "./GraphDetail42.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536db134",
  null
  
)

export default component.exports